export const ASSESSMENT_FOOTER = 111;
export const QUIZ_FOOTER = 72;
